import "./index.scss";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
// import GameSelectButton from "../../GameSelectButton/index";
import { Link } from "react-router-dom";
import {
  selectUiWords,
  selectDifficulty,
  setEndlessCategories,
} from "../../../Store/store";
import { useSelector, useDispatch } from "react-redux";
import ReadyToStart from "../ReadyToStart";

const DifficultySelect = (props) => {
  const uiWords = useSelector(selectUiWords);
  const reduxDifficulty = useSelector(selectDifficulty);
  const dispatch = useDispatch();
  const [difficulty, setDifficulty] = useState(null);
  useEffect(() => {
    setDifficulty(null);
  }, []);
  const resetSelections = () => {
    setDifficulty(null);
    props.resetSelections();
  };

  const DifficultyReturn = ({ term }) => {
    let data = uiWords.find((d) => d.English === term);
    if (data !== undefined && data.Language.length > 0) {
      return (
        <div className="EM-DS-textcontainer">
          <p className="EM-DS-languagetext">{data.Language}</p>
        </div>
      );
    } else {
      return (
        <div className="EM-DS-textcontainer">
          <p className="EM-DS-englishtext">{term}</p>
        </div>
      );
    }
  };
  return (
    <div className="EM-DS-fullscreen">
      <div className="EM-topBanner">
        <div className="EM-topBanner-inner">Select a Difficulty</div>
      </div>
      <div className="EM-DS-buttonContainer">
        <div className="EM-DS-button" onClick={() => setDifficulty("Easy")}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setDifficulty("Easy"); } }}
          role="button" tabIndex={0} aria-label="Easy difficulty">
          <DifficultyReturn term="Easy" />
        </div>
        <div className="EM-DS-button" onClick={() => setDifficulty("Medium")}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setDifficulty("Medium"); } }}
          role="button" tabIndex={0} aria-label="Medium difficulty">
          <DifficultyReturn term="Medium" />
        </div>
        <div className="EM-DS-button" onClick={() => setDifficulty("Hard")}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setDifficulty("Hard"); } }}
          role="button" tabIndex={0} aria-label="Hard difficulty">
          <DifficultyReturn term="Hard" />
        </div>
      </div>
      <div className="EM-DS-bottomdisplay">
        <div className="EM-DS-bottomheader">
          <div className="EM-DS-bottomheader-text">{props.game}</div>
        </div>
        <div className="EM-DS-categoryContainer">
          {props.categories.map((datum) => {
            return (
              <div className="EM-DS-categoryText" key={datum}>
                {datum}
              </div>
            );
          })}
        </div>
      </div>
      {difficulty !== null ? (
        <ReadyToStart
          children={
            <div style={{ width: "100%", height: "100%" }}>
              <div className="EM-DS-textContainer">
                <div className="EM-DS-headercontainer">
                  <div className="EM-DS-headertext">{props.game}</div>
                </div>
                <div className="EM-DS-categoryContainerFull">
                  {props.categories.map((datum) => (
                    <div className="EM-DS-categoryText" key={datum}>
                      {datum}
                    </div>
                  ))}
                </div>
                <div className="EM-DS-difficultyDisplay">{difficulty}</div>
              </div>
              <div className="EM-DS-flex">
                <div className="EM-CS-button-goback" onClick={resetSelections}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); resetSelections(); } }}
                  role="button" tabIndex={0} aria-label="Reselect options">
                  Reselect
                </div>
                <Link
                  to={{
                    pathname: `/endless-mode/start-game/`,
                    search: `game-type=${props.game}&difficulty=${difficulty}&categories=${props.categories}`,
                  }}
                  state={{
                    categories: props.categories,
                    difficulty: reduxDifficulty,
                    endless: true,
                  }}
                  onClick={() =>
                    dispatch(setEndlessCategories(props.categories))
                  }
                >
                  <div className="EM-CS-button-continue">Start Playing</div>
                </Link>
              </div>
            </div>
          }
        />
      ) : null}
    </div>
  );
};

export default DifficultySelect;

DifficultySelect.propTypes = {
  categories: PropTypes.array,
  game: PropTypes.string,
  resetSelections: PropTypes.func,
};
